// extracted by mini-css-extract-plugin
export default {"root":"_0ZUQZkyA_JoK1zcnkFq","plus":"H5RvteHGqw1tt5_6HsG_"};